<template>
  <div>
    <b-breadcrumb class="breadcrumb">
      <b-breadcrumb-item href="/">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
        首页
      </b-breadcrumb-item>
      <b-breadcrumb-item href="/info-main"> 就业资讯 </b-breadcrumb-item>
      <b-breadcrumb-item active>资讯详情</b-breadcrumb-item>
    </b-breadcrumb>

    <h2>{{ infoObj.contentTitle }}</h2>
    <div class="hr-line-solid"></div>
    <b-row>
      <b-col>
        <div>{{ infoObj.editTime }}</div>
      </b-col>
      <b-col cols="9">
        <div class="text-right mr-2"><label class="font-weight-bolder">关键词：</label>{{ infoObj.antistop }}</div>
      </b-col>
    </b-row>
    <div class="hr-line-solid"></div>
    <b-row>
      <b-col cols="9">
        <b-card no-body class="border-0">
          <div class="line-indent content-font" v-html="infoObj.contentTxt"></div>
        </b-card>
      </b-col>
      <b-col>
        <b-card body-class="otherInfoCard">
          <template #header>
            <small class="text-muted font-weight-bolder">相关资讯</small>
          </template>
          <b-list-group flush>
            <b-list-group-item class="otherInfoCard content-font" v-for="(item, index) in otherInfoList" :key="index">
              <label class="text-danger font-weight-bolder">{{ index + 1 }}、</label><b-link :to="'/show-info/' + item.contentId" target="_self" class="news-list">{{ item.contentTitle }}</b-link>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'ShowInfo',
  data() {
    return {
      // 就业资讯id
      infoId: undefined,
      // 就业信息详情对象
      infoObj: undefined,
      // 不包含当前资讯信息的其它咨询列表
      otherInfoList: []
    }
  },
  watch: {
    $route(to, from) {
      if (to.params.id !== from.params.id) {
        window.scrollTo(0, 0)
        this.infoId = to.params.id
        this.fetchInfo()
        this.fetchOtherInfoList()
      }
    }
  },
  created() {
    this.infoId = this.$route.params.id
  },
  mounted() {
    this.fetchInfo()
    this.fetchOtherInfoList()
  },
  methods: {
    /**
     * 获取就业资讯信息详情
     */
    fetchInfo() {
      const that = this
      const postData = {
        id: that.infoId
      }
      that
        .$http({
          method: 'post',
          url: '/portal/policy-info',
          data: postData
        })
        .then((d) => {
          this.infoObj = d
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取就业资讯信息详情失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    },
    /**
     * 获取不包含当前资讯信息的资讯列表
     */
    fetchOtherInfoList() {
      const that = this
      const postData = {
        id: that.infoId
      }
      that
        .$http({
          method: 'post',
          url: '/portal/policy-list-no-include',
          data: postData
        })
        .then((d) => {
          this.otherInfoList = d
        })
        .catch((error) => {
          const msg = error.message
          const errMsg = '获取不包含当前资讯信息的资讯列表失败(错误：' + msg + ')'
          if (error) {
            that.$message({
              message: errMsg,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.hr-line-solid {
  border-top: 1px solid #d3d3d3;
  color: #fff;
  background-color: #faebd7;
  height: 1px;
  margin: 20px 0;
}

.otherInfoCard {
  padding: 10px;
}
</style>
